import {Injectable} from '@angular/core';
import {AppUrl} from '../constants/app-url';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {data} from 'autoprefixer';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  getIcons(): Observable<any> {
    return this.getRequest(AppUrl.GET_ICONS());
  }
}

